var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-modal-backdrop",class:{
          hidden: !_vm.visible,
          'visible-backdrop': _vm.visible
        },on:{"click":_vm.backdropClick}}),_c('div',{staticClass:"my-modal-wrapper elevation-5",class:{
          hidden: !_vm.visible,
          'visible-wrapper': _vm.visible,
          'pa-2': !_vm.noPadding
        },style:(_vm.wrapperStyle)},[_vm._t("header",function(){return [(_vm.header != null)?_c('h2',{staticClass:"mb-2",class:{
              'd-flex': _vm.closeButton
            },style:({
              'padding-right': _vm.closeButton ? '2px' : '5px'
            })},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.header)}}),(_vm.closeButton)?_c('v-spacer'):_vm._e(),(_vm.closeButton)?_c('v-btn',{staticClass:"mr-0",attrs:{"x-small":"","color":"primary"},on:{"click":_vm.hide}},[_vm._v("Close")]):_vm._e()],1):_vm._e()]}),_c('div',{style:(_vm.contentStyle)},[_vm._t("default")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }